/**
 * @description
 * Objeto dbmodels
 */

import { Dbattrs } from "./dbattrs.model";
import { Xmldefs } from "./xmldefs.model";
import { Dbindices } from "./dbindices.model";

export class Dbmodels {
    public id:number = null;
    public code:string = "";
    public description:string;
    public dbattrId: Dbattrs = new Dbattrs();
    public xmldefId: Xmldefs = new Xmldefs();
    public dbobjname:string;
    public indice: number = 0;
    public dbindices: Dbindices[] = [];
    public info: boolean = true;
    constructor() {}
  
}